import {useHistory} from 'react-router';

import IconButton from 'components/IconButton';

import styles from './Back.module.scss';
import classNames from 'classnames';
type BackProps = {
  className?: string;
};

function Back({className}: BackProps) {
  const {goBack} = useHistory();
  const goBackHandler = () => {
    goBack();
  };

  return (
    <IconButton
      icon="arrow_left"
      className={classNames(styles.root, className)}
      onClick={goBackHandler}
    />
  );
}

export default Back;
